<template>
    <div @click="login" :class="[{ small: smallLogo, 'gmail-button': true, disabled }]">
        <div :class="[{ small: smallLogo, icon: true }]">
            <img v-if="!smallLogo" src="../assets/google-logo.png" alt="" />
            <img v-if="smallLogo" src="../assets/google-small-logo.png" alt="" />
        </div>
        <span v-if="!smallLogo" class="text">{{ translate('auth_login_button_google') }}</span>
    </div>
</template>

<script>
import { isLoggedIn } from '@/lib/user.js'
import thirdPartyLoginMixin from '@/mixins/3rd-party-login'
import helper from '@/lib/helper.js'
import helperMixins from '@/mixins/helper.js'
import popup from '@/lib/popup.js'

export default {
    name: 'GmailLoginButton',

    mixins: [thirdPartyLoginMixin, helperMixins],

    props: {
        webviewRedirectTo: {
            type: String,
            default: '#'
        },

        smallLogo: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledMessage: {
            type: String,
            default: 'This feature is not available on this platform'
        }
    },

    methods: {
        isLoggedIn() {
            return isLoggedIn()
        },

        login() {
            if (this.disabled) {
                return popup.alert(this.disabledMessage)
            }

            if (this.isWebView()) {
                return this.tryRedirectLogin('gmail', this.webviewRedirectTo)
            }

            this.$emit('try-login')

            this.tryLogin('gmail')
                .then(payload => {
                    this.$emit('verified', payload.token)
                })
                .catch(() => {
                    this.$emit('fail')
                })
        },

        isWebView() {
            return helper.webView()
        }
    }
}
</script>

<style lang="scss">
.gmail-button {
    background-color: #0177ff;
    padding: 0.6rem;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:hover {
        background-color: #0071f2;
    }

    .icon {
        background: #fff;
        padding: 4px;
        border-radius: 100%;
        width: 28px;
        height: 28px;
        margin-right: 1rem;

        img {
            width: 100%;
        }

        &.small {
            width: 38px;
            height: 38px;
            margin: 8px;
            padding: 0;
        }
    }

    .text {
        color: #fff;
        font-size: 18px;
    }

    .short {
        display: none;
    }

    &.small {
        background-color: #fff;
        box-shadow: 0 0 14px rgba(0, 0, 0, 0.25);
        border: 1px solid #cccccc;
        padding: 0;
        border-radius: 8px;
    }
}
</style>
